var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{attrs:{"type":"button"},on:{"click":function($event){_vm.editor.chain().focus().toggleBold().run()}}},[_vm._v("\n        Bold\n    ")]),_vm._v(" "),_c('editor-content',{attrs:{"editor":_vm.editor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }